













































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { InvoiceModule } from '@/store/modules/invoice';
import { UserModule } from '@/store/modules/user';
import {
  stringToNumber,
  stringFromIDate,
  stringToIDate,
  formatApiError,
  monthStringToIDate,
  formatDate,
} from '@/utils/index';
import { AppRoleType } from '@/utils/types';
import { agentSummaryById } from '@/utils/agent';
import { AgentTypeEnum, IDate, ProductTypeEnum } from '@/api/types';
import { search_invoices } from '@/api/invoice';
import { list_agent_summaries, listAgentSummaries } from '@/api/agent';
import { list_product_summaries } from '@/api/product';

type ItemType = {
  text: string;
  value: string;
};

type WithFiscalYear = {
  fiscalYear: number;
};

@Component({
  name: 'InvoiceListSearch',
})
export default class InvoiceListSearch extends Vue {
  @Prop({ required: true }) products!: Map<
    string,
    list_product_summaries.Product
  >;
  public static readonly invoiceSearchEvent = 'invoice-search';
  private readonly currentYear = new Date().getFullYear();
  private readonly agentTypeAll = '';
  private openPanels = [0];
  private valid = false;
  private agents: Map<string, list_agent_summaries.AgentSummary> = new Map();
  private agentType = this.agentTypeAll;
  private agentTypeItems: ItemType[] = [];
  private agentIds: string[] = [];
  private agentItems: ItemType[] = [];
  private agentIdRules: ((v: string[]) => boolean | string)[] = [];
  private targetYear: number | null = null;
  private targetYearItems: {
    text: number;
    value: number;
  }[] = [];
  private yearText = '';
  private yearMenu = false;
  private targetYearRules: ((v: number | null) => boolean | string)[] = [];
  private invoiceTypes: string[] = [];
  private invoiceTypeItems: ItemType[] = [];
  private statuses: string[] = [];
  private statusItems: ItemType[] = [];
  private paymentStatuses: string[] = [];
  private paymentStatusItems: ItemType[] = [];
  private accountingSlipStatuses: string[] = [];
  private accountingSlipStatusItems: ItemType[] = [];
  private targetProductIds: string[] = [];
  private allProductItems: (ItemType & WithFiscalYear)[] = [];
  private productItems: ItemType[] = [];
  private priceRangeFrom: number | null = null;
  private priceRangeTo: number | null = null;
  private generatedFromMenu = false;
  private generatedFromDate: string | null = null;
  private generatedToMenu = false;
  private generatedToDate: string | null = null;
  private paidFromMenu = false;
  private paidFromDate: string | null = null;
  private paidToMenu = false;
  private paidToDate: string | null = null;

  get minTargetYear() {
    return this.currentYear - 10;
  }

  get maxTargetYear() {
    return this.currentYear + 10;
  }

  get canSearch() {
    return this.valid;
  }

  mounted() {
    this.loadInvoiceListSearchForm();
    this.fetchData();
    this.$nextTick(() => {
      this.loadRules();
      this.$nextTick(() => {
        if (this.canSearch) {
          this.search();
        }
      });
    });
  }

  search() {
    const req: search_invoices.Request = {
      agentIds: this.agentIds,
      statuses: this.statuses as search_invoices.InvoiceStatusEnum[],
    };
    if (this.targetYear !== null) {
      req.targetYear = this.targetYear;
    }
    if (this.invoiceTypes && this.invoiceTypes.length > 0) {
      req.invoiceTypes = this.invoiceTypes as search_invoices.InvoiceTypeEnum[];
    }
    if (this.paymentStatuses && this.paymentStatuses.length > 0) {
      req.paymentStatuses = this
        .paymentStatuses as search_invoices.PaymentStatusEnum[];
    }
    if (this.accountingSlipStatuses && this.accountingSlipStatuses.length > 0) {
      req.accountingSlipStatuses = this
        .accountingSlipStatuses as search_invoices.AccountingSlipStatusEnum[];
    }
    if (this.priceRangeFrom !== null || this.priceRangeTo !== null) {
      req.priceRange = {};
      this.priceRangeFrom !== null &&
        (req.priceRange.from = this.priceRangeFrom!);
      this.priceRangeTo !== null && (req.priceRange.to = this.priceRangeTo!);
    }
    if (this.generatedFromDate !== null || this.generatedToDate !== null) {
      req.generatedDateRange = {};
      this.generatedFromDate !== null &&
        (req.generatedDateRange.start = stringToIDate(this.generatedFromDate)!);
      this.generatedToDate !== null &&
        (req.generatedDateRange.end = stringToIDate(this.generatedToDate)!);
    }
    if (this.paidFromDate !== null || this.paidToDate !== null) {
      req.paidDateRange = {};
      this.paidFromDate !== null &&
        (req.paidDateRange.start = stringToIDate(this.paidFromDate)!);
      this.paidToDate !== null &&
        (req.paidDateRange.end = stringToIDate(this.paidToDate)!);
    }
    this.$emit(InvoiceListSearch.invoiceSearchEvent, req);
    InvoiceModule.SaveInvoiceListSearchForm({
      agentType: this.agentType,
      agentIds: this.agentIds,
      targetYear: this.targetYear,
      invoiceTypes: this.invoiceTypes,
      statuses: this.statuses,
      paymentStatuses: this.paymentStatuses,
      accountingSlipStatuses: this.accountingSlipStatuses,
      targetProductIds: this.targetProductIds,
      priceRangeFrom: this.priceRangeFrom,
      priceRangeTo: this.priceRangeTo,
      generatedFromDate: this.generatedFromDate,
      generatedToDate: this.generatedToDate,
      paidFromDate: this.paidFromDate,
      paidToDate: this.paidToDate,
    });
  }

  reset() {
    InvoiceModule.ClearInvoiceListSearchForm();
    this.loadInvoiceListSearchForm();
  }

  private loadInvoiceListSearchForm() {
    this.agentType = InvoiceModule.invoiceListSearchForm.agentType;
    this.agentIds = InvoiceModule.invoiceListSearchForm.agentIds;
    this.targetYear = InvoiceModule.invoiceListSearchForm.targetYear;
    this.invoiceTypes = InvoiceModule.invoiceListSearchForm.invoiceTypes;
    this.statuses = InvoiceModule.invoiceListSearchForm.statuses;
    this.paymentStatuses = InvoiceModule.invoiceListSearchForm.paymentStatuses;
    this.accountingSlipStatuses =
      InvoiceModule.invoiceListSearchForm.accountingSlipStatuses;
    this.targetProductIds =
      InvoiceModule.invoiceListSearchForm.targetProductIds;
    this.priceRangeFrom = InvoiceModule.invoiceListSearchForm.priceRangeFrom;
    this.priceRangeTo = InvoiceModule.invoiceListSearchForm.priceRangeTo;
    this.generatedFromDate =
      InvoiceModule.invoiceListSearchForm.generatedFromDate;
    this.generatedToDate = InvoiceModule.invoiceListSearchForm.generatedToDate;
    this.paidFromDate = InvoiceModule.invoiceListSearchForm.paidFromDate;
    this.paidToDate = InvoiceModule.invoiceListSearchForm.paidToDate;
  }

  private async fetchData() {
    AppModule.StartProgress();
    await Promise.all([
      this.loadAgentTypeItems(),
      this.loadInvoiceTypeItems(),
      this.loadStatusItems(),
      this.loadPaymentStatusItems(),
      this.loadAccountingSlipStatusItems(),
      this.loadAllProductItems(),
      await this.loadAgentItems(),
    ]);

    AppModule.StopProgress();
  }

  private loadAgentTypeItems() {
    this.agentTypeItems = [
      {
        text: this.$t('All') as string,
        value: this.agentTypeAll,
      },
      {
        text: this.$t(
          `InvoiceTypeEnum.${search_invoices.InvoiceTypeEnum.BOOKING_INVOICE}`
        ) as string,
        value: search_invoices.InvoiceTypeEnum.BOOKING_INVOICE as string,
      },
      {
        text: this.$t(
          `InvoiceTypeEnum.${search_invoices.InvoiceTypeEnum.AGENTCY_INVOICE}`
        ) as string,
        value: search_invoices.InvoiceTypeEnum.AGENTCY_INVOICE as string,
      },
    ];
  }

  private loadInvoiceTypeItems() {
    this.invoiceTypeItems = Object.values(search_invoices.InvoiceTypeEnum)
      .filter(
        t =>
          (t as search_invoices.InvoiceTypeEnum) !==
          search_invoices.InvoiceTypeEnum.UNKNOWN_TYPE
      )
      .map(t => ({
        text: this.$t(`InvoiceTypeEnum.${t}`) as string,
        value: t as string,
      }));
  }

  private loadStatusItems() {
    this.statusItems = Object.values(search_invoices.InvoiceStatusEnum)
      .filter(
        s =>
          (s as search_invoices.InvoiceStatusEnum) !==
          search_invoices.InvoiceStatusEnum.UNKNOWN_STATUS
      )
      .map(s => ({
        text: this.$t(`InvoiceStatusEnum.${s}`) as string,
        value: s as string,
      }));
  }

  private loadPaymentStatusItems() {
    this.paymentStatusItems = Object.values(search_invoices.PaymentStatusEnum)
      .filter(
        s =>
          (s as search_invoices.PaymentStatusEnum) !==
          search_invoices.PaymentStatusEnum.UNKNOWN_PAYMENT_STATUS
      )
      .map(s => ({
        text: this.$t(`PaymentStatusEnum.${s}`) as string,
        value: s as string,
      }));
  }

  private loadAccountingSlipStatusItems() {
    this.accountingSlipStatusItems = Object.values(
      search_invoices.AccountingSlipStatusEnum
    )
      .filter(
        s =>
          (s as search_invoices.AccountingSlipStatusEnum) !==
          search_invoices.AccountingSlipStatusEnum
            .UNKNOWN_ACCOUNTING_SLIP_STATUS
      )
      .map(s => ({
        text: this.$t(`AccountingSlipStatusEnum.${s}`) as string,
        value: s as string,
      }));
  }

  private loadAllProductItems() {
    this.allProductItems = [];
    this.products.forEach(p => {
      if ((p.type as ProductTypeEnum) !== ProductTypeEnum.FREE_MATERIAL) {
        this.allProductItems.push({
          text: `[${this.$t(
            'ProductTypeEnum.' + p.type
          )}] ${this.getProductName(p)}`,
          value: p.id,
          fiscalYear: p.fiscalYear,
        });
      }
    });
    this.filterProductItems();
  }

  private async loadAgentItems() {
    try {
      const listAgentsRes = await listAgentSummaries({
        agentTypes: Object.values(AgentTypeEnum).filter(
          t =>
            (t as AgentTypeEnum) === AgentTypeEnum.OVERSEAS_BUYOUT ||
            (t as AgentTypeEnum) === AgentTypeEnum.DOMESTIC_BUYOUT ||
            (t as AgentTypeEnum) === AgentTypeEnum.DOMESTIC_AGENCY
        ),
      } as list_agent_summaries.Request);
      this.agents = agentSummaryById(listAgentsRes.agentSummaries);
      this.filterAgentItems(false);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Agent'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private filterAgentItems(updateAgentIds = true) {
    if (this.agentType !== this.agentTypeAll && updateAgentIds) {
      this.agentIds = [];
    }

    const items: ItemType[] = [];
    let condition: (a: list_agent_summaries.AgentSummary) => boolean = _ =>
      true;
    if (this.agentType) {
      if (
        this.agentType ===
        (search_invoices.InvoiceTypeEnum.BOOKING_INVOICE as string)
      ) {
        condition = a =>
          (a.type as AgentTypeEnum) === AgentTypeEnum.OVERSEAS_BUYOUT ||
          (a.type as AgentTypeEnum) === AgentTypeEnum.DOMESTIC_BUYOUT;
      } else if (
        this.agentType ===
        (search_invoices.InvoiceTypeEnum.AGENTCY_INVOICE as string)
      ) {
        condition = a =>
          (a.type as AgentTypeEnum) === AgentTypeEnum.DOMESTIC_AGENCY;
      } else {
        condition = _ => false;
      }
    }
    this.agents.forEach(a => {
      if (condition(a)) {
        items.push({
          text: a.name,
          value: a.id,
        });
      }
    });
    this.agentItems = items;
  }

  private loadRules() {
    this.agentIdRules = [
      (v: string[]) =>
        true ||
        (!!v && v.length > 0) ||
        (this.$t('{msg} is required', {
          msg: this.$t('Agent'),
        }) as string),
    ];
    this.targetYearRules = [
      (v: number | null) =>
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('Target year'),
        }) as string),
    ];
  }

  private handleYearSelected() {
    if (this.yearText) {
      this.targetYear = stringToNumber(this.yearText.slice(0, 4))!;
    } else {
      this.targetYear = null;
    }
    this.yearMenu = false;
    this.filterProductItems();
  }

  private filterProductItems() {
    this.targetProductIds = [];
    let productItems: ItemType[];
    if (this.targetYear) {
      productItems = this.allProductItems.filter(
        p =>
          p.fiscalYear >= this.targetYear! - 1 &&
          p.fiscalYear <= this.targetYear! + 1
      );
    } else {
      productItems = this.allProductItems;
    }
    this.productItems = productItems;
  }

  private targetYearAllowedDates(val: string | null) {
    return !val || !this.targetYear || !val.startsWith(`${this.targetYear}`);
  }

  private getProductName(product: list_product_summaries.Product) {
    return `${
      this.$i18n.locale !== 'ja' && this.products.get(product.id)!.nameEn
        ? this.products.get(product.id)!.nameEn
        : this.products.get(product.id)!.name
    }${
      this.products.get(product.id)!.fiscalYear === 0
        ? ''
        : ' [' + this.products.get(product.id)!.fiscalYear + ']'
    }`;
  }

  private generatedFromAllowedDates(val: string | null) {
    return !val || !this.generatedToDate || val <= this.generatedToDate;
  }

  private generatedToAllowedDates(val: string | null) {
    return !val || !this.generatedFromDate || val >= this.generatedFromDate;
  }

  private paidFromAllowedDates(val: string | null) {
    return !val || !this.paidToDate || val <= this.paidToDate;
  }

  private paidToAllowedDates(val: string | null) {
    return !val || !this.paidFromDate || val >= this.paidFromDate;
  }
}
